(() => {
    Metro.i18n.add("pt-BR", {
        weekStart: 0,

        january: "Janeiro",
        february: "Fevereiro",
        march: "Março",
        april: "Abril",
        may: "Maio",
        june: "Junho",
        july: "Julho",
        august: "Agosto",
        september: "Setembro",
        october: "Outubro",
        november: "Novembro",
        december: "Dezembro",

        january_short: "Jan",
        february_short: "Fev",
        march_short: "Mar",
        april_short: "Abr",
        may_short: "Mai",
        june_short: "Jun",
        july_short: "Jul",
        august_short: "Ago",
        september_short: "Set",
        october_short: "Out",
        november_short: "Nov",
        december_short: "Dez",

        sunday: "Domingo",
        monday: "Segunda-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",

        sunday_short: "Dom",
        monday_short: "Seg",
        tuesday_short: "Ter",
        wednesday_short: "Qua",
        thursday_short: "Qui",
        friday_short: "Sex",
        saturday_short: "Sáb",

        sunday_short_2: "Do",
        monday_short_2: "Se",
        tuesday_short_2: "Te",
        wednesday_short_2: "Qu",
        thursday_short_2: "Qi",
        friday_short_2: "Sx",
        saturday_short_2: "Sa",

        label_ok: "OK",
        label_cancel: "Cancelar",
        label_done: "Concluído",
        label_today: "Hoje",
        label_now: "Agora",
        label_clear: "Limpar",
        label_help: "Ajuda",
        label_yes: "Sim",
        label_no: "Não",
        label_random: "Aleatório",
        label_save: "Salvar",
        label_reset: "Redefinir",
        label_submit: "Enviar",
        label_add_user_color: "Adicionar às amostras",
        label_send: "Enviar",
        label_accept: "Aceitar",
        label_cookies_title: "Este site usa cookies",
        label_cookies_text: "Este site usa cookies para garantir que você tenha a melhor experiência em nosso site.",
        label_choose_file: "Escolher arquivo(s)",
        label_drop_file: "Clique ou arraste arquivo(s) aqui",
        label_files_selected: "{n} arquivo(s) selecionado(s)",

        label_days: "dias",
        label_hours: "horas",
        label_minutes: "min",
        label_seconds: "seg",
        label_month: "mês",
        label_months: "meses",
        label_day: "dia",
        label_year: "ano",
        label_years: "anos",

        label_rows_count: "Mostrar:",
        label_search: "Pesquisar:",
        label_table_info: "Mostrando $1 a $2 de $3 registros",
        label_prev: "Anterior",
        label_next: "Próximo",
        label_all: "Todos",
        label_inspector: "Inspetor",
        label_goto_page: "Ir para",
        label_enter_page: "Digite a página...",
        label_empty: "Nada para mostrar",
        label_user_colors: "Cores do Usuário",
        label_tiles: "Blocos",
        label_list: "Lista",
        label_load_more: "Carregar mais",
        label_buy: "Comprar",
        label_buy_now: "Compre agora",
        label_buy_today: "Compre hoje",
        label_download: "Baixar",
        label_search_results: "Resultados da pesquisa",
        label_add: "Adicionar",
        label_edit: "Editar",
        label_delete: "Excluir",
        label_new: "Novo",
        label_sell: "Vender",
        label_details: "Detalhes",
        label_sorting: "Ordenação",
        label_finish: "Finalizar",
        label_play: "Reproduzir",
        label_pause: "Pausar",
        label_stop: "Parar",
        label_mute: "Silenciar",
        label_loop: "Repetir",

        label_on: "ligado",
        label_off: "desligado",

        label_rename_tab: "Renomear aba",
        label_close_tab: "Fechar aba",
        label_close_other_tabs: "Fechar outras abas",
        label_close_tabs_left: "Fechar abas à esquerda",
        label_close_tabs_right: "Fechar abas à direita",
        label_close_all_tabs: "Fechar todas as abas",
        label_close_inactive_tabs: "Fechar abas inativas",

        label_clear_input: "Limpar entrada",
        label_reveal_password: "Revelar senha",
        label_hide_password: "Ocultar senha",
        label_generate_random: "Gerar valor aleatório",
        label_search_input: "Pesquisar pelo valor digitado",

        label_note: "Nota",
        label_tip: "Dica",
        label_info: "Informação",
        label_warning: "Aviso",
        label_question: "Pergunta",
        label_error: "Erro",
        label_success: "Sucesso",
        label_caution: "Cuidado",
        label_alert: "Alerta",
        label_bug: "Bug",
        label_fuck: "Droga",
        label_important: "Importante",
        label_shit: "Merda",
        label_air: "Ar",

        label_select_all: "Selecionar tudo",
        label_select_more: "Selecionar...",
        label_select: "Selecionar",
        label_filter: "Filtrar",

        label_collapse: "Recolher",
        label_attach: "Anexar",
    });
})();
